<app-traitement-data titre="Type de masque" [sousTitre]="patient!.tableauDeBord?.typeDeMasque?.date | aLaDateDu"
    [statut]="patient!.tableauDeBord?.typeDeMasque?.value ? 'info' : 'warning'">
    {{ patient!.tableauDeBord?.typeDeMasque?.value ?? 'Pas de donnée' }}
</app-traitement-data>